// extracted by mini-css-extract-plugin
export default {"container":"_dc7278e3","wrapper":"_21ee0cb7","header":"_3187639b","searchTerm":"_e0365344","subHeader":"_4106ed1f","withFollowButton":"_d7bf9761","fewerResultsHeader":"_c99563a2"};